import { Box, Heading, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';
import { UI } from 'src/apps/invest/common/shells/UI';
import { Accreditation } from './Accreditation';

import { EmploymentForm } from './EmploymentForm';
import { ExitTimingForm } from './ExitTiming';
import { ExperienceForm } from './ExperienceForm';
import { FinancesForm } from './FinancesForm';
import { ObjectivesForm } from './ObjectivesForm';

const Section: React.FC<PropsWithChildren> = ({ children }) => (
  <Box
    width="full"
    borderWidth={['0px', '1px']}
    borderColor="blackAlpha.100"
    borderRadius={'10px'}
    padding={['0px', '30px']}>
    {children}
  </Box>
);

export const InvestorProfilePage: React.FC = () => {
  return (
    <UI>
      <VStack w="full" align="start" gap={['60px', '20px']}>
        <Heading fontSize={'24px'}>Investor Profile</Heading>
        <Section>
          <FinancesForm />
        </Section>
        <Section>
          <EmploymentForm />
        </Section>
        <Section>
          <ExperienceForm />
        </Section>
        <Section>
          <ObjectivesForm />
        </Section>
        <Section>
          <ExitTimingForm />
        </Section>
        <Section>
          <Accreditation />
        </Section>
      </VStack>
    </UI>
  );
};
